var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center animation-opacity pt-2"},[_c('div',[_c('h1',{staticClass:"app-private-title"},[_vm._v("Obteniendo Información")]),_c('div',{staticClass:"text-center mt-1"},[_c('v-progress-circular',{staticClass:"p-color-primary",attrs:{"size":30,"width":7,"indeterminate":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }